// extracted by mini-css-extract-plugin
export const landing = "index-module--landing--iffb4";
export const landingImage = "index-module--landingImage--3hp9z";
export const landingContainer = "index-module--landingContainer--2uFTT";
export const landingTitle = "index-module--landingTitle--1Fjuq";
export const landingCaption = "index-module--landingCaption--20QY3";
export const about = "index-module--about--Lvj3S";